module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_blue_06-226df2c31fd485be97d373001952da87.svg";